import React from 'react';

import { permissionChecks } from '../../../../../utils/permission-check';
import { ViewSettings } from '../../../../../viewer/view-settings';
import { useActiveTimelineContainer } from '../../../../hooks/use-active-timeline-container';
import { useFeatureFlag } from '../../../../hooks/use-feature-flag';
import { SkyviewContext } from '../../../skyview/skyview-state';
import { useViewSettings } from '../../toolbar/tools/view-settings/use-view-settings';

/**
 * The timeline the timeline bar shows: the active one, but none in the CAD viewer, which has no
 * timeline data. ViewSettings.hasViewsInTimelineBar asks the same.
 */
const useTimelineBarTimeline = () => {
  // Re-renders when the CAD viewer opens or closes
  useViewSettings();
  const activeTimelineContainer = useActiveTimelineContainer();

  return !ViewSettings.instance.isCadViewer &&
    permissionChecks.hasAccessToFeature('feature:viewer:toolbar:timeline')
    ? activeTimelineContainer
    : undefined;
};

/**
 * Is the timeline bar shown at the top of SkyView? It then has the views in its notch, in place of
 * the toolbar's and those by the orientation cube: beside the timeline, or alone in the CAD viewer.
 */
const useShowsTimelineBar = () => {
  const enabled = useFeatureFlag('SK-7562-timeline-bar');
  const { activeScene } = React.useContext(SkyviewContext);
  const timeline = useTimelineBarTimeline();

  return (
    enabled && activeScene !== 'panoramaViewer' && (!!timeline || ViewSettings.instance.isCadViewer)
  );
};

export { useShowsTimelineBar, useTimelineBarTimeline };
